import { useEffect } from 'react';
import { useQuery } from '@tanstack/react-query';
import { getDrug } from '@medifind/interface';
import { setAdditionalRouteParams, useRouteStore } from '@medifind/zustand';

export const useDrugParams = () => {
  const {
    routeUUID,
    pathParams: { drugId },
  } = useRouteStore();

  const { data: drugData, isPending } = useQuery({
    queryKey: ['drugData', drugId],
    queryFn: () => getDrug(drugId).catch(() => ({})),
    enabled: !!drugId,
    staleTime: Infinity,
  });

  useEffect(() => {
    if (drugData && !isPending) {
      const drugName = drugData.exemplarGenericName;
      const conditionList = (drugData?.conditionScores || []).map((item) => {
        return {
          display: item.conditionName,
          value: item.tcId,
        };
      });
      setAdditionalRouteParams({ drugName, conditionList: conditionList }, routeUUID);
    }
  }, [drugData, routeUUID, isPending]);

  return null;
};
